export const colors = {
  darkGray: '#37445a',
  lightGray: '#f2f3fb',
  white: '#ffffff',
  primary: '#3d4a8f',
  secondary: '#00798c',
  third: '#aaacaf',
  success: '#00c853',
  dark: '#343a40',
  warning: '#ffc107',
  info: '#126eab',
  danger: '#dc2633',
  light: '#f8f9fa',
};
